import { useFilterConfig } from '../hooks/useFilterConfig';
import { PaginatedSelectFilter } from './reusableFilters/PaginatedSelectFilter';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { RequiredAppsInstalledFilter } from './singleUseFilters/RequiredAppsInstalledFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function WorkflowTemplateFilterControls() {
  const {
    HUB_PLAN,
    OBJECTIVE,
    REQUIRED_APP_IDS,
    REQUIRED_AGENT_IDS
  } = useFilterConfig();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: HUB_PLAN
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: OBJECTIVE,
      multi: true
    }), /*#__PURE__*/_jsx(RequiredAppsInstalledFilter, {}), /*#__PURE__*/_jsx(PaginatedSelectFilter, {
      filter: REQUIRED_APP_IDS
    }), /*#__PURE__*/_jsx(PaginatedSelectFilter, {
      filter: REQUIRED_AGENT_IDS
    })]
  });
}